import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import TdsPreviewModal from '../components/tds/TdsPreviewModal';

/**
 * Direct SEO URL: /tds/pvc-susp-brand-sg5-tds-pdf
 * Opens in-page PDF viewer. ?pdf=1 opens PDF file directly; ?download=1 starts download.
 */
const TdsDetailPage = () => {
  const { code: slugParam } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const openPdfDirect = searchParams.get('pdf') === '1' || searchParams.get('open') === 'pdf';
  const autoDownload = searchParams.get('download') === '1';

  return (
    <TdsPreviewModal
      slug={slugParam}
      onClose={() => navigate('/tds')}
      openPdfDirect={openPdfDirect}
      autoDownload={autoDownload}
    />
  );
};

export default TdsDetailPage;
